import { ArrowLeft, Leaf } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface MobileHeaderProps {
  title?: string;
  showBack?: boolean;
  showLogo?: boolean;
  rightElement?: React.ReactNode;
  className?: string;
}

export function MobileHeader({ 
  title, 
  showBack = false, 
  showLogo = false,
  rightElement,
  className 
}: MobileHeaderProps) {
  const navigate = useNavigate();

  return (
    <header className={cn(
      'sticky top-0 z-40 h-14 flex items-center justify-between px-4 bg-background/95 backdrop-blur-sm border-b border-border safe-area-pt',
      className
    )}>
      <div className="flex items-center gap-2 min-w-[48px]">
        {showBack && (
          <Button 
            variant="ghost" 
            size="icon" 
            onClick={() => navigate(-1)}
            className="h-10 w-10 -ml-2"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
        )}
        {showLogo && (
          <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center">
            <Leaf className="h-4 w-4 text-primary-foreground" />
          </div>
        )}
      </div>
      
      {title && (
        <h1 className="font-display font-semibold text-lg absolute left-1/2 -translate-x-1/2 max-w-[calc(100%-120px)] truncate px-2">
          {title}
        </h1>
      )}
      
      <div className="min-w-[48px] flex justify-end">
        {rightElement}
      </div>
    </header>
  );
}
